module.exports = __webpack_public_path__ + "static/dallas-8c609d90ade429a5b91be22c30d3266c.jpg";